/* eslint-disable camelcase */
import { instanceOEF, segundaVersaoOEF } from './api'

export const postNovaSenhaLogado = ( { nova_senha, senha_atual } ) => {
  return instanceOEF.patch( `${segundaVersaoOEF}/associado/redefinir-senha`, { nova_senha, senha_atual } )
}

export const postEsqueciSenha = ( email, captcha, redirectTo ) => {
  return instanceOEF.post( `${segundaVersaoOEF}/esqueci-minha-senha`, { email, captcha, redirectTo } )
}

export const postNovaSenhaNaoLogado = ( novaSenha ) => {
  return instanceOEF.post( `${segundaVersaoOEF}/redefinir-senha`, novaSenha )
}
